import { StoreClass } from "../stores/Store";

class SyneriseClass {

    store: StoreClass

    push(eventName, params) {
        if (window.SR && SR.event.trackCustomEvent) {
            SR.event.trackCustomEvent(eventName, params);
        }else if (window.syneriseLayer) {
            window.syneriseLayer.push({ event: eventName, params });
        }
        console.log('Synerise', eventName, params);
    }

    setStore(store) {
        this.store = store;
    }

    getConfiguratorParams() {
        const s = this.store;
        if (!s?.product) return {};
        return {
            projekt_id: s.product.id,
            value: s.cart?.totalPrice ?? 0,
            sku: s.product.stockId,
            'rozmiar.powierzchni.spania': s.getStepByType('radio_dimensions')?.selectedOption?.name,
            'wysokosc.wezglowia': s.getStepByType('select_headboard')?.selectedOption?.name,
            'kolekcja.tkanin': s.getStepByType('fabric_component')?.selectedOption?.fabricCategoryName,
            'kolor': s.getStepByType('fabric_component')?.selectedOption?.name,
            'stelaz': s.getStepByType('select_frame')?.selectedOption?.name,
            'materac.rodzaj': s.selectedMattress?.map(m => m.name).join(', ') || null,
            'materac.rozmiar': s.mattresSize || null,
            'rodzaj.wezglowia': s.getStepByType('select_headboard_type')?.selectedOption?.name,
            'strona.lozka': s.getStepByType('select_bed_side')?.selectedOption?.name,
        };
    }
}

const Synerise = new SyneriseClass();

export {
    Synerise,
    SyneriseClass
};
